/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:14
 * @LastEditTime: 2023-05-08 17:15:45
 * @FilePath: \web-app\src\network\other\workOrder.js
 * @Environment: Vue + Element
 * @Description: 工单管理
 */
import { request } from "../request.js";

// 列表
export function officialTweetList(data) {
	return request({
		url: "/web/back/sys/doc/officialTweetList",
		method: "post",
		data,
	});
}
export function ywDetails(params) {
	//文章详情运维管理
	return request({
		url: "/web/back/home/doc/selectDetailForOM",
		method: "get",
		params,
	});
}
// 推送
export function messagePush(data) {
	return request({
		url: "/web/back/wx/send/message",
		method: "post",
		data,
	});
}
// 获取文章id
export function detailNoNav(data) {
	return request({
		url: "/web/back/home/doc/detailNoNav",
		method: "get",
		data,
	});
}
// 获取文章
export function navList(params) {
	//分类列表
	return request({
		url: "/web/back/home/navigation/docNavList49",
		method: "get",
		params,
	});
}
// 下架原因
export function soldOutList(data) {
	//分类列表
	return request({
		url: "/web/back/sys/dict/selectByParentType",
		method: "POST",
		data,
	});
}
export function sortSave(data) {
	//分类列表
	return request({
		url: "/web/back/sys/navigationDoc/save",
		method: "POST",
		data,
	});
}

//文章列表
export function repDocList(data) {
	//文章列表
	return request({
		url: "/web/back/sys/doc/repDocList",
		method: "POST",
		data,
	});
}

// url列表
export function urlList(data) {
    return request({
        url: '/rep/web/reptile/list',
        method: 'POST',
        data
    })
}

//修改文章
export function updateDoc(data) {
    return request({
        url: '/web/back/sys/doc/updateDoc',
        method: 'POST',
        data
    })
}


// 上传图片
export function uploadDocImg(data) {
    return request({
        url: '/web/back/sys/doc/uploadDocImg',
        method: 'POST',
        data
    })
}
// 上传文章
export function uploadDocCollect(data) {
    return request({
        url: '/web/back/sys/doc/docCollect',
        method: 'POST',
        data
    })
}
//查询所有全局频道
export function selectAllList(data) {
    return request({
        url: '/web/back/channel/selectAllList',
        method: 'GET',
        data
    })
}
